export default __webpack_public_path__ + "static/media/line.d6c0989b.svg";